import { MarkdownContent } from "@/components/MarkdownContent";
import { Card } from "@/components/ui/card";
import type { BizminerPillarInsight } from "@/types/serializers";
import { withFunctionalInsightLayout } from "./withFunctionalInsightLayout";

interface DeepDiveProps {
  pillar_insight: BizminerPillarInsight;
  category_id: string;
  current_tab: string;
}

function DeepDive({ pillar_insight, category_id }: DeepDiveProps) {
  const category = pillar_insight.analysis?.categories?.find(
    (c) => c.id === category_id,
  );

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <MarkdownContent
          content={category?.insights?.deep_dives || "No deep dive content available."}
        />
      </Card>
    </div>
  );
}

DeepDive.layout = withFunctionalInsightLayout;

export default DeepDive;
